<template>
    <form v-on:submit.prevent="click" v-if="place">

        <div class="row">
            <div class="col-md-12">
                <!-- Custom Tabs -->
                <div class="nav-tabs-custom">
                    <ul class="nav nav-tabs">
                        <li class="active">
                            <a href="#tab_1" data-toggle="tab">Generali</a>
                        </li>
                    </ul>
                    <div class="tab-content">
                        <div class="tab-pane active" id="tab_1">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="nome">Nome</label>
                                                <input type="text" class="form-control" id="nome"
                                                       name="nome"
                                                       v-model="place.nome" :disabled="disabled">
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="indirizzo">Indirizzo</label>
                                                <input type="text" class="form-control" id="indirizzo"
                                                       name="indirizzo"
                                                       v-model="place.indirizzo" :disabled="disabled">
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="lat">Lat</label>
                                                <input type="text" class="form-control" id="lat"
                                                       name="lat"
                                                       v-model="place.lat" :disabled="disabled">
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="lng">Lng</label>
                                                <input type="text" class="form-control" id="lng"
                                                       name="lng"
                                                       v-model="place.lng" :disabled="disabled">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- /.tab-pane -->

                    </div>
                    <!-- /.tab-content -->

                    <div class="box-footer">
                        <div class="row">
                            <div class="col-md-2 col-md-offset-10">
                                <button class="btn btn-success btn-block" v-if="!disabled">
                                    <i class="fa fa-circle-o-notch fa-spin" v-if="loader"></i>
                                    Salva
                                </button>

                                <button class="btn btn-warning btn-block" v-on:click.prevent="activateMod"
                                        v-if="disabled">
                                    Attiva modifiche
                                </button>
                            </div>
                        </div>
                    </div>

                </div>
                <!-- nav-tabs-custom -->
            </div>
        </div>

    </form>
</template>

<script>
  import { clientDateFormat } from '../../filters'
  import placesApi from '../../api/places'

  export default {
    props: ['disabled', 'place', 'loader', 'showLabels'],
    methods: {
      click () {
        this.$emit('click', this.place)
      },
      error (e) {
        console.log(e)
      },
      activateMod () {
        this.$emit('activate-mod', this.place)
      }
    },
    data () {
      return {
        config: {
          format: clientDateFormat
        },
        places: []
      }
    },
    computed: {
      donazione_tipi () {
        return this.$store.state.decoder.decoders['_dDonationTypes']
      }
    },
    beforeCreate () {
      placesApi.index()
        .then((response) => {
          this.places = response.data.data
        })
    },
    components: {}
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/places/Form.vue